module.exports = __webpack_public_path__ + "media/images/animations/axle_spacing/4-14340788b165c2bc45542401ebe5852a.png";